import React, { useEffect, useState } from "react";
import BreadCrumb from "../../components/Breadcrumb";
import { Chart } from "react-google-charts";
import { useDispatch, useSelector } from "react-redux";
import { getPersonalComission } from "../../actions/profileAction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../components/Loader";
const Report = () => {
  const dispatch = useDispatch();
  const comissionData = useSelector(
    (state) => state.profile.personalCommission
  );
  const [chartData, setChartData] = useState(null);
  const currentYear = new Date();
  const [selectedDate, setSelectedDate] = useState(currentYear);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    dispatch(
      getPersonalComission(currentYear.getFullYear(), () => {
        setLoading(false);
      })
    );
  }, []);

  useEffect(() => {
    if (comissionData?.monthWiseData?.length > 0) {
      const chartData = [
        ["Month", "Commission"],
        ...comissionData?.monthWiseData.map((entry) => [
          entry.month_name,
          parseFloat(entry.total_commission),
        ]),
      ];
      setChartData(chartData);
    } else {
      setChartData(null);
    }
  }, [comissionData]);
  return (
    <div className="report-page">
      <BreadCrumb pageName="Reports" />
      <h3 className="page-title">Reports</h3>
      <p className="page-desc">View your reports</p>
      <div className="row">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="col-md-6">
              <div className="earnings-container">
                <div className="d-flex align-items-center">
                  <h2 className="mr-2">Total Commission Earned in Year</h2>
                  <div className="date-picker">
                    <div
                      className="date-picker inside"
                      onClick={() => {
                        setOpenCalendar(!openCalendar);
                      }}
                    >
                      <div className="icon">
                        <FontAwesomeIcon icon={faCalendarAlt} />
                      </div>

                      <DatePicker
                        scrollableYearDropdown
                        dateFormat="yyyy"
                        showYearPicker
                        showMonthYearPicker={false} // Hide month and year pickers
                        showFullMonthYearPicker={false}
                        selected={selectedDate}
                        onChange={(date) => {
                          setSelectedDate(date);
                          dispatch(getPersonalComission(date.getFullYear()));
                        }}
                        placeholderText=""
                        open={openCalendar}
                        readOnly
                        onClickOutside={() => {
                          setOpenCalendar(false);
                        }}
                        maxDate={new Date()}
                      />
                    </div>
                    <div
                      className="icon"
                      onClick={() => {
                        setOpenCalendar(false);
                        setSelectedDate(null);
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </div>
                  </div>
                </div>
                <p className="total-earnings">
                  {parseFloat(
                    comissionData?.totalCommission ?? 0
                  ).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "USD",
                  })}
                </p>

                <h3>Earnings Breakdown by Month</h3>
                <table className="earnings-table">
                  <thead>
                    <tr>
                      <th>Month</th>
                      <th>Commission</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comissionData?.monthWiseData.map((entry, index) => (
                      <tr key={index}>
                        <td>{entry.month_name}</td>
                        <td>
                          {parseFloat(entry.total_commission).toLocaleString(
                            "en-US",
                            {
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                              style: "currency",
                              currency: "USD",
                            }
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-md-12 mt-5">
              <div className="chart-container ml-5">
                {chartData && (
                  <Chart
                    width={"600px"}
                    height={"300px"}
                    chartType="BarChart"
                    loader={<div>Loading Chart...</div>}
                    data={chartData}
                    options={{
                      title: "Commission Earnings by Month",
                      chartArea: { width: "50%" },
                      hAxis: {
                        title: "Total Earnings",
                        minValue: 0,
                        titleTextStyle: {
                          fontSize: 14,
                          italic: false,
                          bold: true,
                        },
                        format: "currency", // Use currency format
                      },
                      vAxis: {
                        title: "Month",
                        titleTextStyle: {
                          fontSize: 14,
                          italic: false,
                          bold: true,
                        },
                        format: "currency",
                      },
                      titleTextStyle: {
                        fontSize: 16,
                        italic: false,
                      },
                    }}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Report;
